import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import Helmet from 'react-helmet';
import { withStyles } from '@material-ui/styles';
import {
    Grid,
    List,
    ListItem,
    ListItemText,
    Divider,
    Button,
} from '@material-ui/core';
import 'react-day-picker/lib/style.css';
import { preselectedRanges } from './preselected-ranges';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
        color: theme.palette.text.blue,
    },
    presetList: {
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        paddingRight: '0px !important',
        paddingLeft: '0px !important',
    },
    actions: {
        textAlign: 'right',
        paddingTop: '0px !important',
    },
    container: {
        width: '100%',
        margin: 0,
    },
});

const DatePickerOverrides = () => (
    <Helmet>
        <style>{`
          .Range .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
            background-color: #f0f8ff !important;
            color: #4a90e2;
          }
          .Range .DayPicker-Day {
              border-radius: 0 !important;
          }
          .Range .DayPicker-Months {
              flex-direction: column;
          }
          .Range .DayPicker-Day--selected.DayPicker-Day--start {
              border-top-left-radius: 50% !important;
              border-bottom-left-radius: 50% !important;
          }
          .Range .DayPicker-Day--selected.DayPicker-Day--end {
              border-top-right-radius: 50% !important;
              border-bottom-right-radius: 50% !important;
          }
      `}</style>
    </Helmet>
);

class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = props.initial || this.getInitialState();
    }

    getInitialState() {
        return {
            from: null,
            to: null,
            enteredTo: null,
            selectedType: null,
        };
    }

    isSelectingFirstDay(from, to, day) {
        const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
        const isRangeSelected = from && to;
        return !from || isBeforeFirstDay || isRangeSelected;
    }

    handleDayClick = day => {
        const { from, to } = this.state;
        if (from && to && day >= from && day <= to) {
            this.handleResetClick();
            return;
        }

        if (this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                from: day,
                to: null,
                enteredTo: null,
                selectedType: {
                    type: 'custom',
                    title: 'Custom',
                },
            });
        } else {
            this.setState({
                to: day,
                enteredTo: day,
            });
        }
    };

    handleDayMouseEnter = day => {
        const { from, to } = this.state;
        if (!this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                enteredTo: day,
            });
        }
    };

    handleResetClick = () => {
        this.setState(this.getInitialState());
    };

    setRange = range => {
        const { onDateSelected } = this.props;
        const { from, to } = range.dates();
        this.setState(
            {
                to,
                from,
                enteredTo: to,
                selectedType: {
                    type: range.type,
                    title: range.title,
                },
            },
            () => onDateSelected(this.state)
        );
    };

    applyRange = () => {
        const { onDateSelected } = this.props;
        onDateSelected(this.state);
    };

    cancelChange = () => {
        const { onDateSelected, initial } = this.props;
        this.setState(initial, () => onDateSelected(initial));
    };

    render() {
        const { from, to, enteredTo, selectedType } = this.state;
        const { classes } = this.props;
        const modifiers = { start: from, end: enteredTo };
        const disabledDays = { before: from };
        const selectedDays = [from, { from, to: enteredTo }];
        return (
            <div>
                <Grid className={classes.container} container spacing={1}>
                    <Grid item className={classes.presetList}>
                        <List component="nav">
                            <ListItem
                                onClick={() =>
                                    this.setState({
                                        selectedType: {
                                            type: 'custom',
                                            title: 'Custom',
                                        },
                                    })
                                }
                                selected={
                                    selectedType &&
                                    selectedType.type === 'custom'
                                }
                                button
                                divider
                            >
                                <ListItemText primary="Custom" />
                            </ListItem>
                            {preselectedRanges.map(range => (
                                <ListItem
                                    key={range.type}
                                    onClick={() => this.setRange(range)}
                                    selected={
                                        selectedType &&
                                        range.type === selectedType.type
                                    }
                                    button
                                >
                                    <ListItemText primary={range.title} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                    <Grid item>
                        <DayPicker
                            className="Range"
                            numberOfMonths={2}
                            month={from}
                            selectedDays={selectedDays}
                            disabledDays={disabledDays}
                            modifiers={modifiers}
                            onDayClick={this.handleDayClick}
                            onDayMouseEnter={this.handleDayMouseEnter}
                        />
                    </Grid>
                </Grid>
                {selectedType && selectedType.type === 'custom' && (
                    <div className={classes.actions}>
                        <Divider />
                        <Button
                            className={classes.button}
                            onClick={this.cancelChange}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            className={classes.button}
                            onClick={this.applyRange}
                            color="primary"
                            disabled={!from || !to}
                        >
                            Apply
                        </Button>
                    </div>
                )}
                <DatePickerOverrides />
            </div>
        );
    }
}

DatePicker = withStyles(styles)(DatePicker);

export { DatePicker };
